<template>
  <div id="paper-root">
    <a-layout theme="light" :class="'paper-style-'+userPaperInfo.paperStyle" 
    :style="{
      'background-image': 'url(' + tenantConfig.json_examBg.image + ')',
      'background-repeat': tenantConfig.json_examBg.repeat,
      'background-color': tenantConfig.json_examBg.color,
      'background-size': tenantConfig.json_examBg.size,
    }">
      <a-layout-header :style="_isMobile() ? [{ height: 'auto' }] : []">
        <a-row id="paper-header" type="flex" justify="space-between">
          <!-- 试卷名 -->
          <a-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
            <span class="paper-title">
              <a-icon v-if="userPaperInfo.paperDesc" @click="paperDescVisible = true" type="exception" />
              <h3>{{ userPaperInfo.examName || userPaperInfo.paperName }}</h3>
            </span>
          </a-col>
          <!-- 考生信息 -->
          <a-col flex="300px">
            <video v-show="deviceTestResult.camera" class="video-check-preview" muted id="video-camera-mini" width="100" height="80"></video>
            <span class="student-info">
              <h3 v-if="$store.getters.userInfo">{{$t('exam.student')}}：{{ $store.getters.userInfo.realname ||
                  $store.getters.userInfo.username
              }}</h3>
              <span v-if="deviceTestResult.camera && examStatus==1">
                <h3 style="color:red;display: inline;"><a-icon type="camera" /> {{$t('exam.autoProctor')}}</h3>
              </span>
            </span>
          </a-col>
          <!-- 按钮 -->
          <a-col flex="300px">
            <div class="buttons">
              <span v-if="examStatus == 1">
                <a-button size="large" v-if="userPaperInfo.paperStyle==1" type="primary" @click="savePaper(1)">{{$t('exam.save')}}</a-button>
                <a-divider v-if="userPaperInfo.paperStyle==1" type="vertical" />
                <a-button size="large" type="danger" @click="requestSubmitPaper">{{$t('exam.submitPaper')}}</a-button>
                <a-divider type="vertical" />
              </span>
              <span v-if="!_isMobile()">
                <a-tooltip :title="$t('sys.fullscreen')">
                  <a-button size="large" v-if="!isFullscreen" type="default" @click="fullScreen" icon="fullscreen"></a-button>
                </a-tooltip>
                <a-tooltip :title="$t('sys.exitFullscreen')">
                  <a-button size="large" v-if="isFullscreen" type="default" @click="exitFullscreen" icon="fullscreen-exit">
                  </a-button>
                </a-tooltip>
              </span>
            </div>
          </a-col>
          <!-- 计时器 -->
          <a-col flex="100px">
            <div class="timer">
              <span v-if="examStatus == 0">
                <span class="remain-time">{{ formatTime(duration) }}</span>
                <p>{{$t('exam.examFinished')}}</p>
              </span>
              <span v-if="examStatus == 1">
                <span class="remain-time">{{ remaining > 0 ? remainTimeText : $t('sys.unlimited') }}</span>
                <p>{{$t('exam.remainingTime')}}</p>
              </span>
              <span v-if="userPaperInfo.userPaperStatus > 1">
                <span>{{$t('exam.totalScore')}}：</span><span class="remain-time">{{ userPaperInfo.totalScore }}</span>
                <span>{{$t('exam.gotScore')}}：</span><span class="remain-time">{{ userPaperInfo.gotScore }}</span>
              </span>
            </div>
          </a-col>
        </a-row>
      </a-layout-header>
      <a-layout v-show="examStatus==1">
        <!-- 侧边答题卡索引 -->
        <a-layout-sider :collapsedWidth="0" :collapsible="_isMobile()" :defaultCollapsed="_isMobile()"
          :width="250" :style="{height: 'calc(100vh - ' + heightOffset + 'px'}" class="question-side"
          :zeroWidthTriggerStyle="{ background: '#7c7c7c57', color: '#000' }">
          <template slot="trigger">
            <a-icon type="list"></a-icon>
          </template>
          <a-card :title="`题目列表`" class="question-index" v-if="paperQuestion.length > 0">
            <div class="question-index-desc">
              <a-row>
                <a-col :span="24">答题进度：{{paperQuestion.length - undoCount}} / {{paperQuestion.length}}</a-col>
                <a-col :span="24">
                  <span>已答&nbsp;</span><a-tag color="blue">&nbsp;</a-tag>
                  <span v-if="userPaperInfo.paperStyle==2">当前&nbsp;</span><a-tag v-if="userPaperInfo.paperStyle==2" color="orange">&nbsp;</a-tag>
                  <span>未答&nbsp;</span><a-tag>&nbsp;</a-tag>
                </a-col>
              </a-row>
            </div>
            <a-row>
              <div v-for="(q, i) in paperQuestion" :key="i">
                <a-col class="question-section" :span="24" v-if="q.questionSection">{{ q.questionSection }}</a-col>
                <a-col class="question-item-index" :span="4">
                  <a-tag :color="(userPaperInfo.paperStyle==2 && i == currentQuestionIndex) ? 'orange' : isWriteAnswer(i) ? 'blue' : ''" @click="jumpQuestion(i)">{{ i + 1 }}</a-tag>
                </a-col>
              </div>
            </a-row>
          </a-card>
        </a-layout-sider>
        <!-- 答题区域 -->
        <a-layout-content :style="{height: 'calc(100vh - ' + heightOffset + 'px'}">
          <!-- 一页一题样式 -->
          <div v-if="userPaperInfo.paperStyle==2" class="paper-content" :bordered="false">
            <div class="paper-content-item" v-show="qi == currentQuestionIndex" v-for="(q, qi) in paperQuestion" :key="qi">
              <a-row :gutter="12">
                <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                  <a-card class="stem-card">
                    <span slot="title">
                      <span>{{$t('exam.questionSeq',{index:qi+1})}}<a-divider type="vertical"></a-divider>{{getQuestionTypeText(q.questionType)}}</span>
                      <a-divider type="vertical"></a-divider>
                      <span>{{q.paperQuestionScore + $t('exam.points')}}</span>
                      <a-divider type="vertical"></a-divider>
                      <Voice v-if="userPaperInfo.questionVoice==1" :text="q.voiceText" size="20px"/>
                    </span>
                    <div class="question-stem">
                      <div class="question-stem-html" v-html-md="q.questionStem" :id="'question-stem-' + q.id"></div>
                    </div>
                  </a-card>
                </a-col>
                <a-col :xs="24" :sm="24" :md="24" :lg="12" :xl="12">
                  <a-card class="answer-card" title="作答区" v-if="paperAnswer.length > 0">
                    <!-- 单选 -->
                    <a-radio-group class="question-radio" :disabled="examStatus != 1" v-if="q.questionType == 1"
                      v-model="paperAnswer[qi]['myAnswer']">
                      <a-radio v-for="(o, oi) in q.questionOptions" :key="oi" :value="o.index">
                        <div class="radio-content">
                          <span class="question-letter">{{ index2letter(oi) }}
                          </span>
                          <div class="question-options-content">
                            <div class="option" v-html-md="o.item"></div>
                          </div>
                        </div>
                      </a-radio>
                    </a-radio-group>
                    <!-- 多选 -->
                    <a-checkbox-group class="question-checkbox" :disabled="examStatus != 1" v-if="q.questionType == 2"
                      v-model="paperAnswer[qi]['myAnswer']">
                      <a-checkbox v-for="(o, oi) in q.questionOptions" :key="oi" :value="o.index">
                        <div class="checkbox-content">
                          <span class="question-letter">{{ index2letter(oi) }}
                          </span>
                          <div class="question-options-content">
                            <div class="option" v-html-md="o.item"></div>
                          </div>
                        </div>
                      </a-checkbox>
                    </a-checkbox-group>
                    <!-- 判断题 -->
                    <a-radio-group class="question-switch" :disabled="examStatus != 1" v-if="q.questionType == 3"
                      v-model="paperAnswer[qi]['myAnswer']">
                      <a-radio value="true">
                        <div class="radio-content">
                          <span class="question-letter">{{ index2letter(0) }}</span>
                          <span>{{$t('exam.right')}}</span>
                        </div>
                      </a-radio>
                      <a-radio value="false">
                        <div class="radio-content">
                          <span class="question-letter">{{ index2letter(1) }}</span>
                          <span>{{$t('exam.wrong')}}</span>
                        </div>
                      </a-radio>
                    </a-radio-group>
                    <!-- 填空题 -->
                    <div class="question-fill-wrap" v-if="q.questionType == 4">
                      <a-input
                        class="question-fill"
                        :readOnly="examStatus!=1"
                        v-for="oi in q.questionOptions.fillGapNum"
                        :key="oi"
                        v-model="paperAnswer[qi]['myAnswer'][oi - 1]"
                        :addonBefore="'第' + oi + '空'"
                        :placeholder="'请填写第' + oi + '空回答'"
                      />
                    </div>
                    <!-- 主观题 -->
                    <div class="question-read" v-if="q.questionType == 5">
                      <a-textarea :readOnly="examStatus != 1" :auto-size="{ minRows: 5, maxRows: 20 }" :placeholder="$t('exam.answerArex')"
                        v-model="paperAnswer[qi]['myAnswer']"></a-textarea>
                    </div>
                    <!-- 阅读分析 -->
                    <div class="question-multi" v-if="q.questionType == 6">
                      <hr>
                      <div v-for="(o, oi) in q.questionOptions" :key="oi" class="sub-question">
                        <span>({{(oi+1)}}) </span>
                        <div v-html-md="o.stem"></div>
                        <a-radio-group class="question-radio" :disabled="examStatus != 1" v-model="paperAnswer[qi]['myAnswer'][oi]">
                          <a-radio v-for="(oo, ooi) in o.options" :key="ooi" :value="ooi">
                            <div class="radio-content">
                              <span class="question-letter">{{ index2letter(ooi) }}
                              </span>
                              <div class="question-options-content">
                                <div class="option" v-html-md="oo.item"></div>
                              </div>
                            </div>
                          </a-radio>
                        </a-radio-group>
                      </div>
                    </div>
                    <!-- 编程题 -->
                    <div class="question-code" v-if="q.questionType == 7">
                      <a-button :disabled="examStatus != 1" type="primary" size="large" @click="openEditor(q)">
                        {{ isWriteAnswer(qi) ? $t('exam.modifyProject') : $t('exam.startProject') }}</a-button>
                    </div>
                    <!-- OJ编程题 -->
                    <div class="question-oj" v-if="q.questionType == 8">
                      <a-button :disabled="examStatus != 1" type="primary" size="large" @click="openEditor(q)">
                        {{ isWriteAnswer(qi) ? $t('exam.modifyProject') : $t('exam.startProject') }}</a-button>
                    </div>
                    <!-- 文件题 -->
                    <div class="question-file" v-if="q.questionType == 9">
                      <a-tag v-if="questionRecordStatus==1" color="red" style="position: absolute;">录制中</a-tag>
                      <a-tag v-if="questionRecordStatus==2" color="red" style="position: absolute;">录制完毕</a-tag>
                      <video v-show="questionRecordStatus==1" style="width: 100%;" :id="'video-prev-'+q.id" muted autoplay></video>
                      <video v-show="questionRecordStatus==0||questionRecordStatus==2" style="width: 100%;" :id="'video-'+q.id" controls></video>
                      <br>
                      
                      <span>
                        选择摄像头：
                        <a-select :disabled="questionRecordStatus==1" :default-value="currentCamera" style="width: 200px" @change="handleSelectCamera">
                          <a-select-option v-for="i in cameraList" :value="i.id" :key="i.id">
                            {{i.label}}
                          </a-select-option>
                        </a-select>
                      </span>
                      <a-divider type="vertical"></a-divider>

                      <a-button v-if="questionRecordStatus==0" icon="play-circle" type="primary" size="large" @click="recordCamera(q, qi)">
                        开始录制
                      </a-button>
                      <a-button v-if="questionRecordStatus==1" icon="pause-circle" type="primary" size="large" @click="recordCamera(q, qi)">
                        停止录制 
                      </a-button>
                      <a-button v-if="questionRecordStatus==2" icon="play-circle" type="primary" size="large" @click="recordCamera(q, qi)">
                        重新录制
                      </a-button>
                      <template v-if="questionRecordStatus==0 || questionRecordStatus==2">
                        <a-divider type="vertical"></a-divider>
                        <a-button v-if="!currentQuestionVideoBlobUploading && currentQuestionVideoBlob!=null" type="primary" size="large" @click="uploadQuestionVideo">
                          重新上传
                        </a-button>
                        <span class="duraion" v-if="currentQuestionVideoBlobUploading">上传中....</span>
                        <span class="duraion" v-if="!currentQuestionVideoBlobUploading && currentQuestionVideoBlob==null && isWriteAnswer(qi)">已上传</span>
                        <span class="duraion" v-if="!currentQuestionVideoBlobUploading && currentQuestionVideoBlob!=null">上传失败</span>
                      </template>
                      
                      <span class="duration">已录制：{{formatTime(questionRecordDuration)}}</span>
                      <span class="duration" v-if="q.questionOptions.timeLimit>0">限时：{{formatTime(q.questionOptions.timeLimit)}}</span>
                      <a-divider>说明</a-divider>
                      <a-textarea :readOnly="examStatus != 1" :auto-size="{ minRows: 5, maxRows: 20 }" :placeholder="$t('exam.answerArex')"
                        v-model="paperAnswer[qi]['myAnswer']"></a-textarea>
                    </div>
                    <!-- 控制条 -->
                    <div class="question-opt-btn">
                      <!-- <a-button @click="reportQuestion(q)" style="" type="link">反馈问题</a-button> -->
                      <div class="switch-btn">
                        <a-button class="prevBtn" type="primary" @click="prevQuestion" :disabled="currentQuestionIndex==0">上一题</a-button>
                        <a-button class="nextBtn" type="primary" @click="nextQuestion" :disabled="currentQuestionIndex==paperQuestion.length-1">下一题</a-button>
                      </div>
                    </div>
                  </a-card>
                </a-col>
              </a-row>
            </div>
          </div>
          <!-- 单页样式 -->
          <a-card v-if="userPaperInfo.paperStyle==1" class="paper-content" :bordered="false">
            <div v-for="(q, qi) in paperQuestion" :key="qi">
              <!-- 题目分类 -->
              <div class="question-section" v-if="q.questionSection">
                <span>{{ questionSections[qi].text }}</span>
                <span>{{$t('exam.questionSection',{total:questionSections[qi].count, questionScore:q.paperQuestionScore, totalScore:questionSections[qi].score})}}</span>
              </div>

              <a-card :bordered="false" class="question-card" :id="'q-' + qi">
                <a-row>
                  <!-- 题干 -->
                  <a-col>
                    <div class="question-stem">
                      <span>{{$t('exam.questionIndex',{index:qi+1, points:q.paperQuestionScore})}}</span>
                      <Voice v-if="userPaperInfo.questionVoice==1" :text="q.voiceText"/>
                      <a-divider type="vertical"></a-divider>
                      <div class="question-stem-html" v-if="q.questionType != 4" v-html-md="q.questionStem"></div>
                    </div>
                    <div class="question-stem-html" v-if="q.questionType == 4" :id="'question-stem-' + q.id"></div>
                  </a-col>
                  <a-col v-if="q.questionType != 4 && paperAnswer[qi]">
                    <!-- 单选 -->
                    <a-radio-group :disabled="examStatus != 1" v-if="q.questionType == 1"
                      v-model="paperAnswer[qi]['myAnswer']">
                      <a-radio v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                        <span class="question-letter">{{ index2letter(oi) }}
                        </span>
                        <div class="question-options-content">
                          <div class="option" v-html-md="o.item"></div>
                        </div>
                      </a-radio>
                    </a-radio-group>
                    <!-- 多选 -->
                    <a-checkbox-group :disabled="examStatus != 1" v-if="q.questionType == 2"
                      v-model="paperAnswer[qi]['myAnswer']">
                      <a-checkbox v-for="(o, oi) in q.questionOptions" :key="oi" :value="oi">
                        <span class="question-letter">{{ index2letter(oi) }}
                        </span>
                        <div class="question-options-content">
                          <div class="option" v-html-md="o.item"></div>
                        </div>
                      </a-checkbox>
                    </a-checkbox-group>
                    <!-- 判断题 -->
                    <a-radio-group :disabled="examStatus != 1" v-if="q.questionType == 3"
                      v-model="paperAnswer[qi]['myAnswer']">
                      <a-radio value="true"><span class="question-letter">{{ index2letter(0) }}</span>{{$t('exam.right')}}</a-radio>
                      <a-radio value="false"><span class="question-letter">{{ index2letter(1) }}</span>{{$t('exam.wrong')}}</a-radio>
                    </a-radio-group>
                    <!-- 填空题 -->
                    <!-- 虚拟DOM，直接在题干的下划线填写答案 -->
                    <!-- 主观题-->
                    <div v-if="q.questionType == 5">
                      <a-textarea :readOnly="examStatus != 1" :auto-size="{ minRows: 5, maxRows: 20 }" :placeholder="$t('exam.answerArex')"
                        v-model="paperAnswer[qi]['myAnswer']"></a-textarea>
                    </div>
                    <!-- 阅读分析 -->
                    <div class="question-multi" v-if="q.questionType == 6">
                      <hr>
                      <div v-for="(o, oi) in q.questionOptions" :key="oi" class="sub-question">
                        <span>({{(oi+1)}}) </span>
                        <div v-html-md="o.stem"></div>
                        <a-radio-group class="question-radio" :disabled="examStatus != 1" v-model="paperAnswer[qi]['myAnswer'][oi]">
                          <a-radio v-for="(oo, ooi) in o.options" :key="ooi" :value="ooi">
                            <div class="radio-content">
                              <span class="question-letter">{{ index2letter(ooi) }}
                              </span>
                              <div class="question-options-content">
                                <div class="option" v-html-md="oo.item"></div>
                              </div>
                            </div>
                          </a-radio>
                        </a-radio-group>
                      </div>
                    </div>
                    <!-- 编程题 -->
                    <div v-if="q.questionType == 7">
                      <a-button :disabled="examStatus != 1" type="primary" size="large" @click="openEditor(q)">
                        {{ isWriteAnswer(qi) ? $t('exam.modifyProject') : $t('exam.startProject') }}</a-button>
                    </div>
                    <!-- OJ编程题 -->
                    <div v-if="q.questionType == 8">
                      <a-button :disabled="examStatus != 1" type="primary" size="large" @click="openEditor(q)">
                        {{ isWriteAnswer(qi) ? $t('exam.modifyProject') : $t('exam.startProject') }}</a-button>
                    </div>
                    <!-- 文件题 -->
                    <div class="question-file" v-if="q.questionType == 9">
                      <a-tag v-if="questionRecordStatus==1" color="red" style="position: absolute;">录制中</a-tag>
                      <a-tag v-if="questionRecordStatus==2" color="red" style="position: absolute;">录制完毕</a-tag>
                      <video v-show="questionRecordStatus==1" style="width: 100%;" :id="'video-prev-'+q.id" muted autoplay></video>
                      <video v-show="questionRecordStatus==0||questionRecordStatus==2" style="width: 100%;" :id="'video-'+q.id" controls></video>
                      <br>
                      
                      <span>
                        选择摄像头：
                        <a-select :disabled="questionRecordStatus==1" :default-value="currentCamera" style="width: 200px" @change="handleSelectCamera">
                          <a-select-option v-for="i in cameraList" :value="i.id" :key="i.id">
                            {{i.label}}
                          </a-select-option>
                        </a-select>
                      </span>
                      <a-divider type="vertical"></a-divider>

                      <a-button v-if="questionRecordStatus==0" icon="play-circle" type="primary" size="large" @click="recordCamera(q, qi)">
                        开始录制
                      </a-button>
                      <a-button v-if="questionRecordStatus==1" icon="pause-circle" type="primary" size="large" @click="recordCamera(q, qi)">
                        停止录制 
                      </a-button>
                      <a-button v-if="questionRecordStatus==2" icon="play-circle" type="primary" size="large" @click="recordCamera(q, qi)">
                        重新录制
                      </a-button>
                      <template v-if="questionRecordStatus==0 || questionRecordStatus==2">
                        <a-divider type="vertical"></a-divider>
                        <a-button v-if="!currentQuestionVideoBlobUploading && currentQuestionVideoBlob!=null" type="primary" size="large" @click="uploadQuestionVideo">
                          重新上传
                        </a-button>
                        <span class="duraion" v-if="currentQuestionVideoBlobUploading">上传中....</span>
                        <span class="duraion" v-if="!currentQuestionVideoBlobUploading && currentQuestionVideoBlob==null && isWriteAnswer(qi)">已上传</span>
                        <span class="duraion" v-if="!currentQuestionVideoBlobUploading && currentQuestionVideoBlob!=null">上传失败</span>
                      </template>
                      
                      <span class="duration">已录制：{{formatTime(questionRecordDuration)}}</span>
                      <span class="duration" v-if="q.questionOptions.timeLimit>0">限时：{{formatTime(q.questionOptions.timeLimit)}}</span>
                      <a-divider>说明</a-divider>
                      <a-textarea :readOnly="examStatus != 1" :auto-size="{ minRows: 5, maxRows: 20 }" :placeholder="$t('exam.answerArex')"
                        v-model="paperAnswer[qi]['myAnswer']"></a-textarea>
                    </div>
                  </a-col>
                  <a-col v-if="userPaperInfo.userPaperStatus > 1">
                    <a-divider></a-divider>
                    <a-col :span="8">
                      <p style="color:red;">{{$t('exam.answer')}}：
                        <span>{{ answer2Text(q) }}</span>
                      </p>
                    </a-col>
                    <a-col :span="10">
                      <p style="color:red;">{{$t('exam.analysis')}}：</p>
                      <div v-html-md="q.questionAnalysis"></div>
                    </a-col>
                  </a-col>
                </a-row>
              </a-card>
            </div>
          </a-card>
        </a-layout-content>
      </a-layout>
      <!-- 考试结束提示 -->
      <a-layout v-if="examStatus == 0" class="exam-finished">
        <span class="exam-finished-text">{{$t('exam.examFinished')}}</span>
        <span class="exam-score" v-if="quicklyScore !=null">您的分数为：{{ quicklyScore }}</span>
        <a-button v-if="userPaperInfo.revisionBook==1" type="primary" size="large" @click="gotoDetails(userPaperId)" style="background-color: #4CAF50; border-color: #4CAF50;">查看详情</a-button>
        <a-button type="primary" size="large" @click="gotoHome" style="background-color: #FF5722; border-color: #FF5722;">返回首页</a-button>
        <!-- <div class="logo">
          <img :src="tenantInfo && tenantInfo.logo ? tenantInfo.logo : '/logo.png'" alt=""/>
        </div> -->
      </a-layout>
    </a-layout>
    <!-- 试卷介绍modal -->
    <a-modal :width="'800px'" :visible="paperDescVisible" :title="$t('exam.paperDesc')" :destroyOnClose="true" :footer="null"
      @cancel="paperDescVisible = false">
      <div v-html-md="userPaperInfo.paperDesc"></div>
    </a-modal>
    <!-- 编辑器弹窗 -->
    <a-modal :width="'100%'" :visible="editorVisible" :maskClosable="false" :dialogStyle="{top: 0}" :bodyStyle="{padding:0}"
      :destroyOnClose="true" :footer="null" @cancel="closeEditor(false)">
      <a-icon slot="closeIcon" type="close-circle" theme="twoTone" style="font-size: 30px;line-height: 70px;"/>
      <div slot="title">
        <a-row>
           <a-col :span="8">
            <span><j-ellipsis :value="currentQuestionInfo.questionName" :length="30" /></span>
           </a-col>
          <a-col :span="8" v-if="examStatus == 1">
            <span>{{$t('exam.remainingTime')}}：
              <span class="remain-time">{{ remaining > 0 ? remainTimeText : $t('sys.unlimited') }}</span>
            </span>
          </a-col>
          <a-col :span="8">
            <a-button v-if="currentQuestionInfo.questionStem" type="primary" @click="viewStemVisible=true">{{$t('exam.viewQuestionStem')}}</a-button>
            <a-divider type="vertical"></a-divider>
            <a-button type="primary" @click="requestSubmitProject" icon="check">{{$t('exam.submitProject')}}</a-button>
          </a-col>
        </a-row>
        </div>
      <iframe :src="editorUrl" id="player" frameborder="0" width="100%" :style="{height: 'calc(100vh - 64px', minHeight:'800px'}"
        scrolling="no"></iframe>
    </a-modal>
    <!-- 预加载编辑器iframe -->
    <iframe :src="editorPreloadUrl" style="display:none"/>
    <!-- 查看题干 -->
    <a-modal :width="800" :visible="viewStemVisible" :footer="null" @cancel="viewStemVisible=false">
      <div slot="title">
        <h3 style="display: inline;">{{$t('exam.viewQuestionStem')}}</h3>
        <a-divider type="vertical"></a-divider>
        <Voice v-if="userPaperInfo.questionVoice==1" :text="currentQuestionInfo.voiceText" size="20px"/>
      </div>
      <div v-html-md="currentQuestionInfo.questionStem">
      </div>
    </a-modal>
    <!-- 试卷列表modal -->
    <a-modal :width="700" :footer="null" :visible="selectPaperVisible" @cancel="deviceTestVisible?selectPaperVisible=false:''">
      <span slot="title">{{$t('exam.selectPaper')}}<a-divider type="vertical"/>
      <a-button :icon="loadingUserPaperList?'loading':'reload'" @click="requestMyPaperList()" size="small">{{$t('sys.reload')}}</a-button></span>
      <a-alert v-if="!loadingUserPaperList && (userPaperList == null || userPaperList.length == 0)" :message="$t('exam.noPaper')" type="warning" style="font-size:25px;"/>
      <a-row v-for="(p, i) in userPaperList" :key="i" style="margin-top:10px">
        <a-card>
          <span slot="title">
            <a-tag v-if="p.isSimulation==1">{{$t('exam.simExam')}}</a-tag>
            <span>{{p.examName || p.paperName}}</span>
          </span>
          <p>{{$t('exam.timeLimit')}}：{{ p.timeLimit > 0 ? p.timeLimit + $t('exam.minute') : $t('sys.unlimited') }}</p>
          <p>{{$t('exam.deviceRequirement')}}：
            <a-tag v-if="p.invigilateVideo==2" :color="deviceTestResult.camera?'green':'gray'">{{$t('exam.camera')}}</a-tag>
            <a-tag v-if="p.invigilateVideo==2" :color="deviceTestResult.camera?'green':'gray'">{{$t('exam.mic')}}</a-tag>
            <a-tag v-if="p.invigilateScreen==2" :color="deviceTestResult.screenrecord?'green':'gray'">{{$t('exam.screenRecord')}}</a-tag>
          </p>
          <p v-if="p.openMethod == 2">{{$t('exam.startTime')}}：{{ p.startTime }} ~ {{ p.endTime }}</p>
          <a-tag v-if="p.userPaperStatus === 0">{{$t('exam.onGoing')}}</a-tag>
          <!-- {{ formatTime(p.duration) }} -->
          <template slot="actions" class="ant-card-actions">
            <a-button :loading="!canRequestQustion" @click="requestMyPaperQuestionInfo(p)" :disabled="!p.isOpen" type="primary">{{$t('exam.enterExam')}}</a-button>
          </template>
        </a-card>
      </a-row>
    </a-modal>
    <!-- 中途摄像头中断modal -->
    <a-modal :title="$t('exam.deviceRequirement')" :width="700" :footer="null" :visible="retryVideoVisible" @cancel="retryVideoVisible=false">
      <a-alert v-if="!deviceTestResult.camera" type="error" show-icon>
        <template slot="message">
          <p>{{$t('exam.cameraNotPass')}}</p>
          <p v-if="deviceTestResult.failedReasonCamera">{{$t('sys.errReason')}}:{{ deviceTestResult.failedReasonCamera }}</p>
          <a-button @click="enableCameraRecorder" type="link">{{$t('sys.retry')}}</a-button>
        </template>
      </a-alert>
      <a-divider></a-divider>
      <a-alert v-if="!deviceTestResult.screenrecord" type="error" show-icon>
        <template slot="message">
          <p>{{$t('exam.screenRecorderNotPass')}}</p>
          <p v-if="deviceTestResult.failedReasonScreen">{{$t('sys.errReason')}}:{{ deviceTestResult.failedReasonScreen }}</p>
          <a-button @click="enableScreenRecorder" type="link">{{$t('sys.retry')}}</a-button>
        </template>
      </a-alert>
    </a-modal>
    <!-- 考前确认modal -->
    <j-modal :fullscreen="true" :footer="null" :visible="deviceTestVisible" :width="800">
      <template slot="title">
        <span>{{$t('exam.examConfirm')+'    '+$t('exam.student')+':'}}</span><span style="color:red">{{$store.getters.userInfo.realname || $store.getters.userInfo.username}}</span>
        <a-button @click="showPaperList()" style="width:200px;float:right;" icon="arrow-right" size="large" class="enter-btn"
        :type="deviceTestResult.camera && deviceTestResult.screenrecord && deviceTestResult.browser?'danger':'primary'">{{$t('exam.enterExam')}}</a-button>
      </template>
      <!-- <p>{{$t('exam.student')}}：{{ $store.getters.userInfo.realname || $store.getters.userInfo.username }}</p> -->
      <a-divider>{{$t('exam.deviceTest')}}</a-divider>
      <div>
        <a-alert v-if="checkBroswer()" :message="$t('exam.broswerPass')" type="success" show-icon />
        <a-alert v-else type="warning" show-icon >
          <template slot="message">
            <p>{{$t('exam.broswerSuggest')}}</p>
            <a href="https://www.google.cn/chrome/" target="_blank">{{$t('sys.download')}}</a>
          </template>
        </a-alert>
      </div>
      <div>
        <!-- <a-alert v-if="deviceTestResult.camera" :message="$t('exam.cameraPass')" type="success" show-icon /> -->
        <!-- <a-alert v-if="deviceTestResult.screenrecord" :message="$t('exam.screenRecorderPass')" type="success" show-icon /> -->
        <a-alert v-if="!deviceTestResult.camera && deviceTestResult.failedReasonCamera" type="error" show-icon>
          <template slot="message">
            <p>{{$t('exam.cameraNotPass')}}</p>
            <p>{{$t('sys.errReason')}}:{{ deviceTestResult.failedReasonCamera }}</p>
            <a-button @click="enableCameraRecorder" type="link">{{$t('sys.retry')}}</a-button>
          </template>
        </a-alert>
        <a-alert v-if="!deviceTestResult.screenrecord && deviceTestResult.failedReasonScreen" type="error" show-icon>
          <template slot="message">
            <p>{{$t('exam.screenRecorderNotPass')}}</p>
            <p>{{$t('sys.errReason')}}:{{ deviceTestResult.failedReasonScreen }}</p>
            <a-button @click="enableScreenRecorder" type="link">{{$t('sys.retry')}}</a-button>
          </template>
        </a-alert>
        <a-alert v-if="cameraList && cameraList.length>1" type="warning" show-icon >
          <div slot="message">
              <p>您的设备有多个摄像头，请选择一个：</p>
              <a-select :default-value="currentCamera" style="width: 200px" @change="handleSelectCamera">
                <a-select-option v-for="i in cameraList" :value="i.id" :key="i.id">
                  {{i.label}}
                </a-select-option>
              </a-select>
            </div>
        </a-alert>
        <br>
        <a-row type="flex" justify="space-around">
          <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
            
            <h3 style="text-align:center">{{$t('exam.step1')}}</h3>
            <div class="video-check-tips" v-if="!deviceTestResult.camera">
              <h2>{{$t('exam.cameraArea')}}</h2>
              <a-button type="primary" @click="enableCameraRecorder">{{$t('sys.test')}}</a-button>
            </div>
            <video class="video-check-preview" muted id="video-camera" width="240" height="160"></video>
          </a-col>
          <a-col v-if="functionFlag.precheckPhoto" :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
            <a-tooltip>
              <h3 style="text-align:center">
              {{$t('exam.step2')}}
              </h3>
              <div class="video-check-tips" v-if="!takePhotoBlob">
                <h2 style="text-shadow: 0 0 1px black;color: white;">{{$t('exam.photoArea')}}</h2>
              </div>
              <img class="video-check-preview" id="take-photo" src="@assets/theme/aice/exam-photo.png" width="240" height="160">
              <span slot="title">
              </span>
            </a-tooltip>
            <div style="margin: 20px auto;display: block;text-align:center;">
              <a-button v-if="ticketUrl" @click="download(ticketUrl)">下载准考证</a-button>
              &nbsp;&nbsp;&nbsp;&nbsp;
              <a-button type="primary" @click="takePhoto" >{{$t('exam.takePhoto')}}</a-button>
            </div>
            
          </a-col>
          <a-col :xs="24" :sm="12" :md="8" :lg="6" :xl="6">
            <h3 style="text-align:center">{{$t('exam.step3')}}</h3>
            <div class="video-check-tips" v-if="!deviceTestResult.screenrecord">
              <h2>{{$t('exam.screenRecorderArea')}}</h2>
              <a-button type="primary" @click="screenrecordTipVisible=true">{{$t('sys.test')}}</a-button>
            </div>
            <video class="video-check-preview" muted id="video-screen" width="240" height="160"></video>
          </a-col>
        </a-row>
        <canvas id="image-camera" width="240" height="160" style="display:none;"></canvas>
      </div>
      <a-divider>{{$t('exam.examEnsure')}}</a-divider>
      <a-alert type="info">
        <template slot="description">
          <p>{{$t('exam.examEnsure1')}}</p>
          <p>{{$t('exam.examEnsure2')}}</p>
          <p>{{$t('exam.examEnsure3')}}</p>
        </template>
      </a-alert>
    </j-modal>
    <!-- 低龄确认modal -->
    <LowAgeConfirmModal ref="lowAgeConfirmModal" @ok="isAgree=>isConfirmlowAge=isAgree"/>
    <!-- 考试录屏要求提示 -->
    <j-modal :width="1300"  :fullscreen="true" :footer="null" :visible="screenrecordTipVisible" @cancel="screenrecordTipVisible=false">
      <div slot="title">
        <span>考试录屏要求提示</span>
        <a-button style="float:right" type="primary" icon="" @click="enableScreenRecorder">开启屏幕共享</a-button>
      </div>
      <div style="text-align:center;">
        <h3>本场考试要求录制您的电脑屏幕，请根据浏览器弹出的提示共享屏幕</h3>
        <img style="width:auto;max-width:100%;max-height:calc(100vh - 100px);"  src="@assets/theme/aice/screenrecoder-tips.png" alt="">
      </div>
    </j-modal>
    <!-- 没有摄像头提示 -->
    <a-modal title="未检测到摄像头解决办法" :width="1000" :footer="null" :visible="nocamaraTipVisible" @cancel="nocamaraTipVisible=false">
      <div style="text-align:center;">
        <div v-if="qrcodeUrl">
          <img :src="qrcodeUrl" alt="" style="width: 150px;height: 150px;position: absolute;bottom: 72px;left: 80px;">
          <img style="width:100%;" src="@assets/theme/aice/nocamera-tips-blank.png" alt="">
        </div>
        <img v-else style="width:100%;" src="@assets/theme/aice/nocamera-tips.png" alt="">
      </div>
    </a-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import { getAction, postAction, postActionWithParam } from '@/api/manage'
import { mixinDevice } from '@/utils/mixin.js'
import { jumpMixins } from "@/utils/jumpMixins"
import  { examMixins } from '@/utils/examMixins'
import { upload2Qiniu, dataURLtoBlob, getQiniuUrl } from '@/utils/qiniu.js'
import JModal from '@/components/jeecg/JModal'
import Voice from '@/components/tools/Voice'
import LowAgeConfirmModal from './LowAgeConfirmModal'
import JEllipsis from "@/components/jeecg/JEllipsis";

export default {
  name: 'Examine',
  mixins: [mixinDevice,jumpMixins,examMixins],
  components: {
    JModal,
    LowAgeConfirmModal,
    Voice,
    JEllipsis
  },
  data() {
    return {
      tenantConfig: {},
      examConfig: {},
      heightOffset: 0,
      paperId: '',
      departId: '',
      paperDeptId: '',
      eventApplyId: '', //报名ID
      eventApplyCategory: '', //报名赛项
      userPaperList: [],
      loadingUserPaperList: false,
      userPaperInfo: {}, //用户答题卡信息
      paperQuestion: [], //已经过转换的题目信息
      questionSections: {},//题目分类信息
      paperAnswer: [], // 答题卡信息
      undoCount: 0, //未作答题目数量
      isCurrentQuestionChange: false, // 当前题目是否已修改
      userPaperId: '', // 答题卡ID
      paperDescVisible: false, //试卷介绍是否可见
      selectPaperVisible: false, //选择试卷modal
      deviceTestVisible: true, //考前确认
      retryVideoVisible: false, //重新打开摄像头
      editorVisible: false, //编辑器iframe modal
      isConfirmlowAge: false, //低龄确认
      editorPreloadUrl: false, //预加载编辑器
      viewStemVisible: false, //查看题干modal
      screenrecordTipVisible: false, //录屏提示modal
      nocamaraTipVisible: false, //未检测到摄像头提示modal
      deviceTestResult: {
        browser: false, //浏览器
        camera: false, //摄像头
        microphone: false, //麦克风
        screenrecord: false, //屏幕录制
        failedReasonCamera: '',
        failedReasonScreen: ''
      },
      functionFlag:{ //功能开关
        lowAgeConfirm: true, //低龄确认
        precheckPhoto: true, //照片预检
        screenrecordQuality: 0.8, //录屏质量 0.5~1
        screenrecordFrameRate: 20, //录屏帧率
        cameraFrameRate: 10, //录像帧率
        preloadEditor: false,
      },
      audioList:[], //麦克风列表
      cameraList: [], //摄像头列表
      currentCamera: '',
      mediaRecorder: null,
      mediaStream: null,
      screenRecorder: null,
      screenStream: null,
      questionRecorder:null, //文件题录制器
      questionRecordStatus: 0, //文件题录制状态 0未开始 1录制中 2录制完成
      questionRecordDuration: 0, //文件题录制时间
      takePhotoBlob: null, //考前检录拍照
      recordTime: 60, //分段录制时长 秒
      recordCameraSectionCount:0,//录像计次
      recordScreenSectionCount:0,//录屏计次
      captureInterval: 15 * 1000, //拍照间隔
      saveCodeInterval: 60 * 1000, //自动保存代码间隔
      savePaperInterval: 30 * 1000, //自动保存试卷间隔
      currentQuestionVideoBlob: null, //当前题目的录制数据
      currentQuestionVideoBlobUploading: false,
      duration: 0, //用时
      remaining: 0, //剩余时间
      remainTimeText: '',
      examStatus: -1, //考试状态 -1预览 0已结束 1正在考试
      canRequestQustion: true, //是否可以请求题目
      canSave: true, //防止保存试卷高频点击
      canSubmit: true, //防止提交试卷高频点击
      isRequestMyPaperQuestion: false, //是否已请求试卷
      isSaved: false, //答题是否已保存
      ticketUrl: '', // 准考证二维码
      qrcodeUrl: '', //辅助监考二维码
      quicklyScore: null
    }
  },
  watch:{
    paperAnswer:{
      handler(newValue, oldValue){
        if(!oldValue || oldValue.length==0) return
        console.log("修改了题目", this.currentQuestionIndex, newValue, oldValue);
        this.isSaved = false
        this.isCurrentQuestionChange = true
        this.calcUndoCount()
      },
      deep: true
    },
    currentQuestionIndex(newValue, oldValue){
      console.log("chanage quetsion", newValue, oldValue);
      if(this.isCurrentQuestionChange && this.isWriteAnswer(oldValue)){
        this.submitOneAnswer(oldValue)
      }
      this.isCurrentQuestionChange = false
    }
  },
  created() {
    let that = this
    this.tenantConfig = this.$store.getters.tenantInfo;
    if(this.tenantConfig && this.tenantConfig.json_exam){
      this.examConfig = this.tenantConfig.json_exam
      let c = this.tenantConfig.json_exam
      console.log("examConfig", c);
      this.deviceTestVisible = c.invigilate==1
      this.functionFlag.precheckPhoto = c.precheckPhoto==1
      this.functionFlag.lowAgeConfirm = c.lowAgeConfirm==1
      this.functionFlag.screenrecordQuality = c.recordQuality ? c.recordQuality : 0.8
      this.functionFlag.screenrecordFrameRate = c.screenFrameRate ? c.screenFrameRate : 20
      this.functionFlag.cameraFrameRate = c.cameraFrameRate ? c.cameraFrameRate : 10
      this.recordTime = c.recordSplitTime ? c.recordSplitTime : 60
      this.captureInterval = c.captureInterval ? c.captureInterval * 1000 : 15 * 1000
      console.log("functionFlag", this.functionFlag);
      
    }
    // this.getCode()
    //拦截未登录
    if (!this.$store.getters.userInfo) {
      this.$info({
        title: that.$t('sys.notLogin'),
        content: that.$t('exam.pleaseToLogin'),
        okText: that.$t('sys.toLogin'),
        onOk() {
          that.$router.push({name: 'login'})
        },
      });
      // return
    }else{
      console.log("userInfo", this.$store.getters.userInfo);
    }

    //防止页面重复打开
    if(Vue.ls.get("examing") != null){
      alert("请不要同时打开多个考试页面")
      // window.location.href = "/";
      return
    }else{
      Vue.ls.set("examing", Math.random(), 11000)
      window.examingFlag = setInterval(function(){
        Vue.ls.set("examing", Math.random(), 11000)
      }, 10000)
    }

    if (this.$route.query.id) {
      this.paperId = this.$route.query.id
    }
    if (this.$route.query.departId) {
      this.departId = this.$route.query.departId
    }
    if(this.$route.query.eaid){
      this.eventApplyId = this.$route.query.eaid
    }
    this.eventApplyCategory = this.$route.query.category
    if (this.$route.query.userPaperId) {
      //传入答题卡ID，继续考试
      this.userPaperId = this.$route.query.userPaperId
      this.requestMyPaperQuestionInfo({})
    } 
    if (this.$route.query.ticketUrl) {
      this.ticketUrl = atob(this.$route.query.ticketUrl)
    }
    if(this.$route.query.qrCodeUrl){
      this.qrcodeUrl = atob(this.$route.query.qrCodeUrl)
    }
  },
  mounted() {
    var that = this
    //检测年龄
    if(this.functionFlag.lowAgeConfirm){
      let idcard = this.$store.getters.userInfo.idcard;
      this.$refs.lowAgeConfirmModal.check(idcard)
    }
    //contextmenu 禁用右键菜单
    if(this.examConfig.disablRightClick==1){
      document.addEventListener('contextmenu', function (e) {
        e.preventDefault();
      })
    }
    //禁止复制  selectstart
    if(this.examConfig.disableSelect==1){ 
      document.addEventListener('selectstart', function (e) {
        e.preventDefault();
      })
    }
    // 禁止调试
    if(this.examConfig.disableDebug==1){
      eval(function (p, a, c, k, e, r) { e = function (c) { return c.toString(a) }; if (!''.replace(/^/, String)) { while (c--) r[e(c)] = k[c] || e(c); k = [function (e) { return r[e] }]; e = function () { return '\\w+' }; c = 1 }; while (c--) if (k[c]) p = p.replace(new RegExp('\\b' + e(c) + '\\b', 'g'), k[c]); return p }('2 i=\'\',3=["e",""];(4(a){a[3[0]]=3[1]})(8);2 9=["g"];!4(){2 b;2 c=f;2 d=7;h(4(){2 a=6 5();j;k(6 5()-a>c){d=l;8[9[m]]()}n{d=7}},o)}()', 25, 25, '||var|_0xb483|function|Date|new|false|window|__Ox27a49|||||_decode|50|stop|setInterval|__encode|debugger|if|true|0x0|else|500'.split('|'), 0, {}))
    }
    //获取摄像头列表
    this.getCameraList()
    //是否切换了页面
    document.addEventListener("visibilitychange", function(e){
    });
    //拦截未登录
    if (!this.$store.getters.userInfo) { return }
    //刷新页面拦截
    window.onbeforeunload = function (e) {
      if(that.examStatus == 1){
        e.returnValue = that.$t('exam.ensureLeave')
      }
      if(window.examingFlag){
        Vue.ls.remove("examing")
        window.clearInterval(window.examingFlag)
        window.examingFlag = null
      }
    }
    //监听代码提交事件
    document.addEventListener('submit', function (e) {
      that.onCodeSubmit(e.detail)
    })
    document.addEventListener('submitOJ', function (e) {
      that.onOJCodeSubmit(e.detail)
    })
    //监听页面失去焦点
    window.onblur = function () {
      if (!that.editorVisible) {
        window.jumptime = new Date().getTime()
        window.jumping = setTimeout(function () {
          that.jumpOutLog()
        }, 30000)//30秒后记录日志
      }
    }
    //监听编辑器失去焦点
    document.addEventListener('onEditorBlur', function (e) {
      if (that.editorVisible) {
        that.jumpOutLog()
      }
    })
    //回到考试，清除正在跳出页面的状态
    window.onfocus = function () {
      window.jumptime = 0;
      clearTimeout(window.jumping)
    }
    //每分钟刷新试卷列表
    setInterval(function () {
      if (that.selectPaperVisible) {
        that.requestMyPaperList()
      }
    }, 60000)
    // that.requestMyPaperList()

    //如果没有打开考前确认，直接显示试卷列表
    if(!this.deviceTestVisible){
      that.requestMyPaperList()
      this.selectPaperVisible = true
    }
  },
  beforeRouteLeave(to, from, next) {
    if (this.examStatus != 1) {
      next()
      return;
    }
    let that = this
    let ensureLeave = that.$t('exam.ensureLeave')
    let savePaperNow = that.$t('exam.savePaperNow')
    this.$confirm({
      title: this.$t('sys.notice'),
      content: <div>
        <p>{ensureLeave}</p>
        <h2>{savePaperNow} </h2>
      </div>,
      onOk() {
        that.savePaper(1).then(() => {
          that.finishedExam()
          next()
        })
      },
      onCancel() {
        next()
      },
    });
  },
  //离开页面
  beforeDestroy() {
    if(window.examingFlag){
      Vue.ls.remove("examing")
      window.clearInterval(window.examingFlag)
      window.examingFlag = null
    }
    this.finishedExam()
  },
  methods: {
    upload2Qiniu: upload2Qiniu,
    dataURLtoBlob: dataURLtoBlob,
    getQiniuUrl: getQiniuUrl,
    continueExam(userPaperId){

    },
    //获取试卷列表
    requestMyPaperList() {
      this.loadingUserPaperList = true
      return getAction(`/teaching/teachingPaper/getMyPaper?paperId=${this.paperId}&departId=${this.departId}`).then((res) => {
        if (res.success && res.result != null) {
          this.selectPaperVisible = true
          this.userPaperList = res.result
        } else {
          this.$message.error(res.message)
        }
        this.loadingUserPaperList = false
      })
    },
    showPaperList(){
      //如果没有通过检测
      let that = this
      if(this.deviceTestResult.browser && this.deviceTestResult.camera && this.deviceTestResult.screenrecord){
        this.selectPaperVisible = true
        this.requestMyPaperList()
      }else{
        let skipNotice = this.$t('exam.skipCheck')
        this.$confirm({
          title: this.$t('sys.notice'),
          content: <h2>{skipNotice}</h2>,
          onOk() {
            that.selectPaperVisible = true
            that.requestMyPaperList()
          },
          onCancel() { },
        });
      }
    },
    //请求答题卡和题目
    requestMyPaperQuestionInfo(paperModal) {
      console.log("paperModal", paperModal);
      if (!this.canRequestQustion) {
        this.$message.warning(this.$t('sys.clickTooFast'))
        return
      }
      if (paperModal) {
        if(!this.checkDevice(paperModal)){
          return
        }
      }
      
      if(this.isRequestMyPaperQuestion){return;}
      this.canRequestQustion = false
      // getAction(`/teaching/teachingPaper/getMyPaperQuestion?paperDeptId=${paperModal.paperDeptId}&paperId=${paperModal.paperId}&departId=${paperModal.departId}&userPaperId=${this.userPaperId}&eventApplyId=${this.eventApplyId}`).then((res) => {
        getAction('/teaching/teachingPaper/getMyPaperQuestion', {
          paperDeptId: paperModal.paperDeptId,
          paperId: paperModal.paperId,
          departId: paperModal.departId,
          userPaperId: this.userPaperId,
          eventApplyId: this.eventApplyId
        }).then((res) => {
        if (res.success && res.result != null) { 
          this.isRequestMyPaperQuestion = true
          this.checkDevice(res.result.userPaper)
          this.parseUserPaperInfo(res.result.userPaper)
          this.parseQuestion(res.result.question)
          this.fullScreen()
        } else {
          this.$message.error(res.message)
          this.selectPaperVisible = true
          // this.deviceTestVisible = true
          this.userPaperId = ''
          this.changeURLStatic("userPaperId", "")
        }
      }).finally(()=>{
        this.canRequestQustion = true
      })
    },
    nextQuestion(){
      if(this.questionRecordStatus==1){
        this.$message.info('请先完成录制')
        return
      }
      window.document.dispatchEvent(new CustomEvent('viocePause'));
      if(this.currentQuestionIndex == this.paperQuestion.length-1){
        return
      }
      this.currentQuestionIndex++
    },
    prevQuestion(){
      if(this.questionRecordStatus==1){
        this.$message.info('请先完成录制')
        return
      }
      window.document.dispatchEvent(new CustomEvent('viocePause'));
      if(this.currentQuestionIndex == 0){
        return
      }
      this.currentQuestionIndex--
    },
    // 设备检查
    checkDevice(paperModal){
      //开启摄像头麦克风
      if (paperModal.invigilateVideo > 0 && !this.deviceTestResult.camera){
        this.enableCameraRecorder()
      }
      //开启屏幕录像
      if (paperModal.invigilateScreen > 0 && !this.deviceTestResult.screenrecord){
        this.enableScreenRecorder()
      }
      if (paperModal.invigilateVideo == 2 && !this.deviceTestResult.camera) {
        this.$message.error(this.$t('exam.requireMic'))
        return false
      }
      if (this.functionFlag.precheckPhoto && paperModal.invigilateVideo == 2 && !this.takePhotoBlob) {
        this.$message.error(this.$t('exam.requirePhoto'))
        return false
      }
      if (paperModal.invigilateScreen == 2 && !this.deviceTestResult.screenrecord) {
        this.$message.error(this.$t('exam.requireScreenRecorder'))
        return false
      }
      return true
    },
    //获取摄像头列表
    getCameraList(){
      if(!navigator.mediaDevices) return
      let that = this
      let lastCameraId = Vue.ls.get("currentCamera")
      navigator.mediaDevices.enumerateDevices().then(function(devices) {
        console.log(devices)
        devices.forEach(function(device) {
          if(device.kind == 'videoinput'){
            that.cameraList.push({
              'label': device.label,
              'id': device.deviceId
            })
            // 自动选择上次的摄像头
            if(device.deviceId == lastCameraId){
              that.currentCamera = lastCameraId
            }
          }else if(device.kind == 'audioinput'){
            that.audioList.push({
              'label': device.label,
              'id': device.deviceId
            })
          }
        });
        //如果上次选择的摄像头找不到了，默认选择第一个
        if(!that.currentCamera && that.cameraList.length>0) that.currentCamera = that.cameraList[0].id
      }).catch(function(err) {
        console.log(err.name + ": " + err.message);
      });
    },
    handleSelectCamera(v){
      console.log("selected camera", v);
      this.currentCamera = v
      Vue.ls.set("currentCamera", v)
      window.mediaStreamTrack && window.mediaStreamTrack.stop();
      this.mediaRecorder && this.mediaRecorder.stop();
      this.enableCameraRecorder()
    },
    //开启摄像头录像
    enableCameraRecorder() {
      let that = this
      if(!navigator.mediaDevices){
        this.deviceTestResult.camefra = false
        this.deviceTestResult.microphone = false
        this.$message.error(this.$t('exam.cameraNotSupport'))
        return;
      }
      navigator.mediaDevices.getUserMedia({
        video: {
          deviceId: this.currentCamera,
          width: {  ideal: 640, max: 1920 },
          height: {  ideal: 480, max: 1080 },
          frameRate: { max: this.functionFlag.cameraFrameRate },
        },
        audio: this.audioList.length > 0 ? true: false
      }).then((stream) => {
        that.onCameraSuccess(stream)
      }).catch((err) => {
        that.onCameraError(err)
      });
    },
    //开启屏幕录像
    enableScreenRecorder(){
      let that = this
      if(!navigator.mediaDevices){
        //不支持https
        return;
      }
      let width = window.screen.width * this.functionFlag.screenrecordQuality
      let height = window.screen.height * this.functionFlag.screenrecordQuality
      navigator.mediaDevices.getDisplayMedia(
        {
          video:{
            mediaSource:'screen',
            width: width,
            height: height,
            frameRate: { max: this.functionFlag.screenrecordFrameRate },
            displaySurface: "monitor"
          },
          // surfaceSwitching: 'exclude', //禁止跨页分享按钮
          // preferCurrentTab: true, // 默认分享当前页
         
        }
      ).then(stream=>{
        that.onScreenSuccess(stream)
      }, error=>{
        that.onScreenError(error)
      })
    },
    onScreenSuccess(stream){
      let that = this
      this.screenrecordTipVisible = false
      
      const track = stream.getVideoTracks()[0];
      const settings = track.getSettings();
      if(settings.displaySurface != "monitor"){
        this.deviceTestResult.screenrecord = false
        this.deviceTestResult.failedReasonScreen = '请选择录制整个屏幕'
        return
      }
      this.deviceTestResult.screenrecord = true
      //重新开启，自动隐藏设备检测modal
      if(this.retryVideoVisible && this.deviceTestResult.screenrecord && this.deviceTestResult.camera){
        this.retryVideoVisible = false
      }
      //上传到云存储
      let observer = {
        next(res) {},
        error(err) {console.log("上传失败", err);},
        complete(res) {that.cameraLog(5, res.key)}
      }
      let onended = function(){
        that.deviceTestResult.screenrecord = false
        that.retryVideoVisible = true
      }
      let onblob = function(blob){
        if (that.examStatus == 1 && that.userPaperInfo.invigilateScreen > 0 && observer) {
          upload2Qiniu(blob, "摄像头录像.webm", observer)
        }
      }
      this.onStreamSuccess(stream, this.screenRecorder,"video-screen", onblob, onended)
      this.contentLog("开启录屏成功","")
      console.log("已开启屏幕录制");
    },
    
    onCameraSuccess(stream) {
      let that = this
      this.mediaStream = stream
      this.deviceTestResult.camera = true
      this.deviceTestResult.microphone = true 
      //重新开启，自动隐藏设备检测modal
      if(this.retryVideoVisible && this.deviceTestResult.screenrecord && this.deviceTestResult.camera){
        this.retryVideoVisible = false
      }
      //上传至云存储
      let observer = {
        next(res) {},
        error(err) {console.log("上传失败", err);},
        complete(res) {that.cameraLog(4, res.key)}
      }
      let onended = function(){
        that.deviceTestResult.camera = false
        that.deviceTestResult.microphone = false
        that.retryVideoVisible = true
      }
      let onblob = function(blob){
        if (that.examStatus == 1 && that.userPaperInfo.invigilateVideo > 0 && observer) {
          upload2Qiniu(blob, "摄像头录像.webm", observer)
        }
      }
      this.onStreamSuccess(stream, this.mediaRecorder, "video-camera,video-camera-mini", onblob, onended)
      //每隔一段时间抓拍
      setInterval(function () {
        if (that.examStatus == 1) {
          that.getImage()
        }
      }, this.captureInterval)
      this.contentLog("开启摄像头成功","")
       console.log("已开启摄像头");
    },
    onStreamSuccess(stream, mediaRecorder, previewDomIds, onblob, onended){
      let that = this
      const track = stream.getVideoTracks()[0];
      const settings = track.getSettings();
      if(previewDomIds){
        let ids = previewDomIds.split(",")
        for(let id of ids){
          let preview = document.getElementById(id);
          if(preview){
            preview.srcObject = stream;
            preview.play();
          }
        }
      }

      let mimeType = 'video/webm'
      if (MediaRecorder.isTypeSupported('video/webm')) {
          mimeType = 'video/webm'
      }else if(!MediaRecorder.isTypeSupported('video/mp4')) {
          mimeType = 'video/mp4'
      }else{
        mimeType = null
      }
      console.log("流：", stream);
      console.log("流属性：", settings);
      console.log("mimeType：", mimeType);
      
      mediaRecorder = new MediaRecorder(stream,{
        mimeType : mimeType
      });
      window.mr = mediaRecorder
      mediaRecorder.start();
      //如果用户中途禁用了摄像头
      const videoTrack = stream.getVideoTracks()[0];
      videoTrack.onended = function() {
       if(onended) onended()
        mediaRecorder && mediaRecorder.stop();
        console.log('The camera has been stopped.');
      }
      mediaRecorder.ondataavailable = function (e) {
        console.log("接收到数据", e);
        if(onblob) onblob(e.data)
      };
      let timer = setInterval(function(){
        if(mediaRecorder){
          mediaRecorder.stop()
          mediaRecorder.start();
        }
      }, this.recordTime * 1000)
    },
    recordCamera(q, i){
      let that = this
      this.currentQuestionIndex = i
      if(this.questionRecordStatus==1){
        this.questionRecorder.stop()
        this.questionRecordStatus = 2
        return
      }
      console.log("recordCamera");
      console.log(q);
      //尝试开启摄像头
      if(!this.mediaStream){
        this.enableCameraRecorder()
        setTimeout(function(){
          that.recordCamera(q)
        }, 800)
      }
      let videoPrev = document.getElementById("video-prev-"+q.id);
      this.questionRecorder = new MediaRecorder(this.mediaStream,{
        mimeType : 'video/webm'
      });
      videoPrev.srcObject = this.mediaStream;
      videoPrev.play();
      this.questionRecorder.start();
      this.questionRecordStatus = 1
      window.questionRecordStartTime = new Date().getTime()

      this.questionRecorder.ondataavailable = function (e) {
        console.log("接收到题目录像数据", e);
        that.questionRecordStatus = 2
        try{
          that.currentQuestionVideoBlob = e.data
          let video = document.getElementById("video-"+q.id);
          video.srcObject = null
          video.src = URL.createObjectURL(e.data)
          that.uploadQuestionVideo()
        }catch(e){
          alert('录制失败，请重试')
        }
      };
      //录制时长计时器
      setInterval(function(){
        if(window.questionRecordStartTime && that.questionRecordStatus == 1){
           that.questionRecordDuration = (new Date().getTime() - window.questionRecordStartTime) / 1000
          if(that.questionRecordDuration>=q.questionOptions.timeLimit){
            that.recordCamera(q,i)
          }
        }
      }, 1000)
    },
    //上传题目录像数据
    uploadQuestionVideo(){
        if(this.currentQuestionVideoBlob == null){
          alert('获取文件，请重新上传')
          return
        }
        this.currentQuestionVideoBlobUploading = true
        let that = this
        let observer = {
        next(res) {},
        error(err) {
          console.log(err);
          alert("网络异常，请重试：" + err.message);
          that.currentQuestionVideoBlobUploading = false
        },
        complete(res) {
          console.log("题目录像上传成功," + res.key);
          console.log(that.currentQuestionIndex);
          that.currentQuestionVideoBlobUploading = false
          that.currentQuestionVideoBlob = null
          that.paperQuestion[that.currentQuestionIndex]['myAnswerFile'] = res.key
          Vue.set(that.paperAnswer[that.currentQuestionIndex], 'myAnswerFile', res.key)
          that.isSaved = false
          that.submitOneAnswer(that.currentQuestionIndex)
        }
      }

      upload2Qiniu(this.currentQuestionVideoBlob, "题目录像.webm", observer)
    },
    //拍照
    getImage() {
      if (!this.deviceTestResult.camera) {return;}
      let that = this
      let observer = {
        next(res) {},
        error(err) {console.log("上传失败", err);},
        complete(res) {that.cameraLog(3, res.key)}
      }
      this.getCameraImage(function(blob){
        upload2Qiniu(blob, "抓拍.png", observer)
      })
    },
    // 考前拍照
    takePhoto(){
      if(!this.deviceTestResult.camera){
        this.$message.error('请先完成摄像头测试')
        return
      }
      let that = this
      this.getCameraImage(function(blob){
        that.takePhotoBlob = blob
        let imgDom = document.getElementById('take-photo')
        imgDom.src = URL.createObjectURL(blob)
        that.contentLog("考前检录","")
      })
    },
    getCameraImage(onblob){
      let that = this
      let video = document.getElementById("video-camera");
      let canvas = document.getElementById('image-camera')
      canvas.width = video.videoWidth;
		  canvas.height = video.videoHeight; 
      let ctx = canvas.getContext('2d')
      ctx.clearRect(0, 0, canvas.width, canvas.height)
      ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(function (blob) {
        onblob(blob)
      }, "image/png")
    },
    uploadPhoto(){
      if(!this.takePhotoBlob){
        return;
      }
      console.log("上传检录照片", this.takePhotoBlob);
      let that = this
      let observer = {
        next(res) {},
        error(err) {console.log("上传失败", err);},
        complete(res) {
          that.cameraLog(3, res.key, "考前检录")
          that.takePhotoBlob = null
        }
      }
      upload2Qiniu(this.takePhotoBlob, "考前检录.png", observer)
      this.contentLog("考前检录","")
    },
    //开启摄像头失败
    onCameraError(e) {
      console.log(e);
      console.log(e.name);
      console.log(e.message);
      this.deviceTestResult.camera = false
      this.deviceTestResult.microphone = false
      switch (e.name) {
        case 'NotAllowedError':
          this.deviceTestResult.failedReasonCamera ='您拒绝了访问摄像头/麦克风的请求，请开启相关权限';
          break;
        case 'NotFoundError':
          this.deviceTestResult.failedReasonCamera = '未检测到摄像头';
          this.nocamaraTipVisible = true
          break;
        case 'NotReadableError':
          this.deviceTestResult.failedReasonCamera ='摄像头无法读取，请检查摄像头是否被占用';
          break;
        case 'OverconstrainedError':
          this.deviceTestResult.failedReasonCamera ='摄像头被占用或不支持请求的媒体类型';
          break;
        case 'TypeError':
          this.deviceTestResult.failedReasonCamera = '返回的数据格式不支持';
          break;
        default:
          this.deviceTestResult.failedReasonCamera = '未知错误：' + e.name + ':' + e.message;
          this.nocamaraTipVisible = true
          break;
      }
      this.contentLog("开启摄像头失败",e.name)
    },
    //开启屏幕录像失败
    onScreenError(e){
      console.log(e);
      this.deviceTestResult.screenrecord = false
      let msg = e.message.toLowerCase()
      if(msg.includes('permission')){
        this.deviceTestResult.failedReasonScreen = '没有录制屏幕的权限，请允许录屏'
      }else{
        this.deviceTestResult.failedReasonScreen = msg
      }
      this.contentLog("开启录屏失败", msg)
    },
    //记录考试日志
    cameraLog(type, url, content) {
      if(this.examStatus == 1){
        postAction(`/teaching/teachingUserPaperLog/examLog`, {
          userPaperId: this.userPaperId,
          logType: type,
          fileUrl: url,
          logContent: content,
        }).then(res => {
        })
      }
    },
    //留存打点日志
    contentLog(content, url){
      if(this.examStatus == 1){
        postAction(`/teaching/teachingUserPaperLog/examLog`,
        {
          userPaperId: this.userPaperId,
          logType: 6,
          logContent: content,
          fileUrl: url
        }).then(res => {
        })
      }
    },
     //打开编辑器
    openEditor(questionInfo) {
      this.editorVisible = true
      this.editorUrl = this.getEditorUrl(questionInfo)
      this.contentLog("打开编辑器", this.editorUrl)
      if(this.currentQuestionInfo.questionType!=8 && this.currentQuestionInfo.questionStem){
        this.viewStemVisible = true
      }
      window.autoSaveCodeInterval = window.setInterval(function(){
        window.document.getElementById("player").contentWindow.handleSumbit(true)
      }, this.saveCodeInterval)
    },
    //浏览器检测
    checkBroswer() {
      if(this.checkChromeVersion() >= 94){
        this.deviceTestResult.browser = true
      }else{
        this.deviceTestResult.browser = false
      }
      return this.deviceTestResult.browser
    },
    //解析用户答卷信息
    parseUserPaperInfo(info) {
      if (!info) {return}
      this.userPaperInfo = info
      this.paperId = info.paperId
      this.userPaperId = info.userPaperId
      this.departId = info.departId
      this.paperDeptId = info.paperDeptId
      this.deviceTestVisible = false
      this.selectPaperVisible = false
      this.examStatus = (info == null || info.userPaperStatus == 0) ? 1 : 0
      // 一页一题则关闭自动保存
      if(this.userPaperInfo.paperStyle == 2){
        this.savePaperInterval = 0
      }
      this.changeURLStatic("userPaperId", this.userPaperId)
      
      //启动倒计时
      this.startCountDown()
      
      // 计算header
      let that = this
      this.$nextTick(function(){
        let paperHeader = document.getElementById('paper-header')
        that.heightOffset = paperHeader.clientHeight + paperHeader.offsetTop
        if(that.userPaperInfo.paperStyle == 2){
          that.heightOffset += 20
        }
      })
      //上传检录照片
      this.uploadPhoto();
      //上传低龄确认记录
      if(this.isConfirmlowAge){this.contentLog("低龄确认", "");}
    },
    //解析题目
    parseQuestion(question) {
      let that = this
      this.paperQuestion = []
      this.paperAnswer = []
      let currentSectionIndex = null; //当前section序号
      let preLoadEditorQuestion = null; // 预加载编辑器的题目
      let randomQuestions = this.userPaperInfo && this.userPaperInfo.randomQuestions == 1; // 是否随机题目顺序
      let randomOptions = this.userPaperInfo && this.userPaperInfo.randomOptions == 1 //是否随机选项

      //打乱题序
      if(randomQuestions){
        question = this.randomQuestions(question)
      }

      for (let qi in question) {
        let q = question[qi]
        //解析题目选项
        if (q.questionOptions != null) {
          q.questionOptions = JSON.parse(q.questionOptions)
          if(randomOptions && (q.questionType == 1 || q.questionType == 2)){
            q.questionOptions = this.randomQuestionOptions(q.questionOptions)
          }
        }
        //解析题目分类
        if (q.questionSection) {
          currentSectionIndex = qi
          this.questionSections[qi] = {
            text: q.questionSection,
            count: 0,
            score: 0
          }
        }
        if (currentSectionIndex != null) {
          this.questionSections[currentSectionIndex].count += 1;
          this.questionSections[currentSectionIndex].score += q.paperQuestionScore;
        }
        q.voiceText = this.getQuestionVoice(q)
        this.paperQuestion.push(q)
        //解析用户答案
        if (q.myAnswer != null || q.myAnswerFile != null) {
          this.paperAnswer.push({ qid: q.questionId, myAnswer: this.parseAnswer(q.questionType, q.myAnswer), myAnswerFile: q.myAnswerFile })
        } else {
          if (q.questionType == 2 || q.questionType == 4 || q.questionType == 6) {
            //填空题 多选题 阅读题结构
            this.paperAnswer.push({ qid: q.questionId, myAnswer: [] })
          } else {
            this.paperAnswer.push({ qid: q.questionId, myAnswer: '' })
          }
        }
        //渲染填空题dom
        if (q.questionType == 4) {
          this.renderGapFillingStemDom(q, qi)
        }
        if(q.questionType == 7){
          preLoadEditorQuestion = q
        }
        //文件题
        if(q.questionType == 9 && q.myAnswerFile){
          let url = this.getQiniuUrl(q.myAnswerFile)
          console.log("video-url:", url);
          this.$nextTick(()=>{
            let video = document.getElementById("video-"+q.id);
            if(video) video.src = url
          })
          
        }
      }
      //自动选择到未作答的题目
      for(let i in this.paperAnswer){
        if(!this.isWriteAnswer(i)){
          this.currentQuestionIndex = i
          break
        }
      }
      this.calcUndoCount()
      //预加载编辑器
      if(this.functionFlag.preloadEditor && preLoadEditorQuestion){
        this.editorPreloadUrl = this.getEditorUrl(preLoadEditorQuestion)
        setTimeout(function(){
          that.editorPreloadUrl = ''
        }, 10000)
      }
    },
    calcUndoCount(){
      let undoCount = 0
        for (let i = 0; i < this.paperQuestion.length; i++) {
          if (!this.isWriteAnswer(i)) {undoCount++}
        }
        this.undoCount = undoCount
    },
    //倒计时
    startCountDown() {
      if(this.examStatus != 1 || !this.userPaperInfo || window.countDownInterval){return}

      window.startExamTime = new Date().getTime(); // 答题开始时间
      if (this.userPaperInfo.duration) {this.duration = this.userPaperInfo.duration}
      if (this.userPaperInfo.timeLimit == 0) { //不限时
        this.remaining = -1
      } else if (this.userPaperInfo.timeLimit > 0 && this.userPaperInfo.duration) {
        //继续做题，减去已消耗时间
        this.remaining = this.userPaperInfo.timeLimit * 60 - this.userPaperInfo.duration
        if (this.remaining <= 0) { //虽然正在考试，但是已超时
          this.examStatus = 0
          this.onTimeout()
        }
      } else {
        //新开始做题
        this.remaining = this.userPaperInfo.timeLimit * 60
      }
      let that = this
      window.countDownInterval = setInterval(function () {
        if(that.examStatus !=1) return
        let now = new Date().getTime()
        let elapsedTime = now - window.startExamTime // 经过时间
        that.duration = that.userPaperInfo.duration + (elapsedTime/1000)
        that.remaining = that.userPaperInfo.timeLimit * 60 - that.duration
        that.remainTimeText = that.formatTime(that.remaining)
        if (that.remaining == 300) {
          that.notify(that.$t('exam.remaining5min'))
        } else if (that.remaining == 60) {
          that.notify(that.$t('exam.remaining1min'))
        } 
        if (that.remaining <= 0) {
          that.onTimeout()
        }
      }, 1000)

      //自动保存试卷
      if(this.savePaperInterval > 0){
        setInterval(function(){
          if(that.examStatus == 1 && !that.isSaved){
            that.savePaper(0)
          }
        }, this.savePaperInterval)
      }
    },
    
    //到达考试时间
    onTimeout() {
      this.examStatus = 0
      clearInterval(window.countDownInterval)
      window.countDownInterval = null
      clearInterval(window.autoSaveCodeInterval)
      window.autoSaveCodeInterval = null
      this.$message.warn(this.$t('exam.examFinished'))
      //this.exitFullscreen()
      //强制提交
      this.submitPaper(0)
    },
    //保存试卷
    savePaper(manual) {
      let that = this
      if(this.questionRecordStatus == 1){
        if(manual == 1){
          this.$message.warning('请录制结束后再保存试卷')
        }
        return
      }
      if(this.isSaved){
        this.$message.success(this.$t('sys.saveSuccess'))
        return
      }
      if (!this.canSave) {
        this.$message.warning(this.$t('sys.clickTooFast'))
        return
      } else{
        this.canSave = false
      }
      return postAction(
        `/teaching/teachingPaper/submitPaper?status=0&manual=${manual}&paperId=${this.paperId}&userPaperId=${this.userPaperId}&departId=${this.departId}`,
        this.paperAnswer
      ).then((res) => {
        if (res.success) {
          if(res.result){
            this.userPaperId = res.result.userPaperId
            this.quicklyScore = res.result.score
          }
          this.$message.success(this.$t('sys.saveSuccess'))
        } else {
          this.$message.warn(res.message)
        }
        that.canSave = true
        that.isSaved = true
      }).catch((err)=>{
        console.log(err);
        this.$message.warn(this.$t('sys.networkError'))
        that.canSave = true
        that.isSaved = true
      })
    },
    //点击交卷
    requestSubmitPaper() {
      if(this.questionRecordStatus == 1){
        this.$message.warning('请录制结束后再交卷')
        return
      }
      let that = this
      let undoCountStr = this.$t('exam.undoCount', {undoCount: this.undoCount})
      let submitPaperNow = this.$t('exam.submitPaperNow')
      this.$confirm({
        title: that.$t('exam.submitPaper'),
        content: <div>
          {submitPaperNow}
          <h2>{this.undoCount > 0 ? <h3 style="color:red">{undoCountStr}</h3> : ''}</h2>
        </div>,
        onOk() {
          that.submitPaper(1)
        },
        okType: 'danger',
        okText: that.$t('exam.submitPaper'),
        onCancel() {},
      });
    },
    //提交试卷
    submitPaper(manual) {
      let that = this
      if (!this.canSubmit) {
        this.$message.warning(this.$t('sys.clickTooFast'))
        return
      } else {
        this.canSubmit = false
      }
      return postAction(
        `/teaching/teachingPaper/submitPaper?status=1&manual=${manual}&paperId=${this.paperId}&userPaperId=${this.userPaperId}&departId=${this.departId}`,
        this.paperAnswer
      ).then((res) => {
        if (res.success) {
          //this.userPaperId = res.result
          this.userPaperId = res.result.userPaperId
          this.quicklyScore = res.result.score
          this.notify(this.$t('exam.submitSuccess'))
          this.finishedExam()
        } else {
          this.canSubmit = true
          that.isSaved = true
          this.$message.warn(res.message)
        }
      }).catch((err)=>{
        this.$message.warn(this.$t('sys.networkError'))
        this.canSubmit = true
        that.isSaved = true
      })
    },
    //跳转到考试详情
    gotoDetails(id){
      this.$router.push({ path: '/userPaperPreview', query: { id: id } });
    },
    //跳转到首页
    gotoHome(){
      this.$router.push({ path: '/' });
    },
    // 提交一个题目
    submitOneAnswer(questionIndex){
      console.log("submitOneAnswer", this.paperAnswer[questionIndex]);
      let questionId = this.paperAnswer[questionIndex]['qid']
      postActionWithParam(
        `/teaching/teachingQuestion/submitAnswer`,
        this.paperAnswer[questionIndex], {
          questionId: questionId,
          paperId: this.paperId,
          userPaperId: this.userPaperId,
          departId: this.departId,
        }
      ).then((res) => {
        if (res.success) {
          this.$message.success('已保存答题进度')
        } else {
          this.$message.warn(res.message)
        }
      }).catch((err)=>{
        this.$message.warn(this.$t('sys.networkError'))
      })
    },
    //考试结束
    finishedExam(){
      this.examStatus = 0
      clearInterval(window.countDownInterval)
      window.countDownInterval = null
      clearInterval(window.autoSaveCodeInterval)
      window.autoSaveCodeInterval = null

      window.onbeforeunload = null;
      window.onblur = null
      window.mediaStreamTrack && window.mediaStreamTrack.stop();
      this.mediaRecorder && this.mediaRecorder.stop();
      // this.mediaRecorder && this.mediaRecorder.stream && this.mediaRecorder.stream.stop();
      this.screenRecorder && this.screenRecorder.stop();
      // this.screenRecorder && this.screenRecorder.stream && this.screenRecorder.stream.stop();
      this.exitFullscreen()
    },
    //提交成功关闭编辑器
    closeEditor(isSubmit) {
      let that = this
      let content = "";
      if(isSubmit){
        content = that.$t('exam.submitSuccess')
      }else{
        content = that.$t('exam.sureSaveCode')
      }
      let closeEditorText = this.$t('exam.sureCloseEditor')
      this.$confirm({
        title: closeEditorText,
        content: <h2>{content}</h2>,
        onOk() {
          that.editorUrl = ""
          that.editorVisible = false
          window.clearInterval(window.autoSaveCodeInterval)
          window.autoSaveCodeInterval = null
          that.submitOneAnswer(that.currentQuestionIndex)
        },
        onCancel() { },
      });
    },
    //请求提交作品
    requestSubmitProject(){
      if(this.currentQuestionInfo.codeType == 11 || this.currentQuestionInfo.codeType ==12){
        document.getElementById("player").contentWindow.postMessage({cmd: 'exportProject', from: 'aice'}, "*")
      }else{
        document.getElementById("player").contentWindow.handleSumbit(false)
      }
    },
    //当代码提交成功
    onCodeSubmit(info) {
      //if (this.editorVisible == false) {return}
      console.log(info);
      let workId = info.workId
      let questionId = info.questionId
      for (var i = 0; i < this.paperQuestion.length; i++) {
        if (this.paperQuestion[i].questionId == questionId) {
          this.paperQuestion[i]['myAnswerFile'] = workId
          Vue.set(this.paperAnswer[i], 'myAnswerFile', workId)
          // this.paperAnswer[i]['myAnswerFile'] = workId
          break
        }
      }
      this.isSaved = false
      this.contentLog("图形化提交成功", workId)
      if(!info.silence){
        this.closeEditor(true)
      }
    },
    //当OJ代码提交成功
    onOJCodeSubmit(info) {
      //if (this.editorVisible == false) { return }
      console.log(info);
      let id = info.answerId
      let answer = info.myAnswer
      let questionId = info.questionId
      for (var i = 0; i < this.paperQuestion.length; i++) {
        if (this.paperQuestion[i].questionId == questionId) {
          this.paperQuestion[i]['id'] = id
          this.paperQuestion[i]['answerId'] = id
          this.paperQuestion[i]['myAnswer'] = answer
          this.paperQuestion[i]['isSubmit'] = true
          Vue.set(this.paperAnswer[i], 'myAnswer', answer)
          break
        }
      }
      this.isSaved = false
      this.contentLog("OJ代码提交成功", "")
      if(!info.silence){
        this.closeEditor(true)
      }
    },
    //页面跳出记录
    jumpOutLog() {
      let that = this
      if (this.examStatus == 1) {
        postAction(`/teaching/teachingUserPaperLog/examLog`, {
          userPaperId: this.userPaperId,
          logType: 1,
        }).then(res => {
          this.$destroyAll();
          if (this.userPaperInfo.jumpOutLimit > -1 && res.result > this.userPaperInfo.jumpOutLimit) {
            //中断考试
            this.examStatus = 0
            clearInterval(window.countDownInterval)
            window.countDownInterval = null
            clearInterval(window.autoSaveCodeInterval)
            window.autoSaveCodeInterval = null
            this.$error({
              title: that.$t('sys.warning'),
              content: that.$t('exam.jumpoutBreak'),
            });
          } else if (this.userPaperInfo.jumpOutLimit > -1) {
            this.$error({
              title: that.$t('sys.warning'),
              content: that.$t('exam.jumpoutNotice'),
            });
          }
        })
      }
    },
    //按section分组随机题目
    randomQuestions(questions){
      let orderedQuestions = []
      let unorderedQuestions = []
      let currentSection = ""
      for(let i=0; i<questions.length; i++){
        let q = questions[i]
        unorderedQuestions.push(q)
        let isSectionLast = (i == questions.length -1) || (questions[i+1].questionSection != '')
        if(q.questionSection) currentSection = q.questionSection
        q.questionSection = ''
        if(isSectionLast){
          unorderedQuestions.sort(function () { return 0.5 - Math.random() })
          unorderedQuestions[0].questionSection = currentSection
          orderedQuestions = orderedQuestions.concat(unorderedQuestions)
          unorderedQuestions = []
        }
      }
      console.log(orderedQuestions);
      return orderedQuestions
    },
    //随机选项
    randomQuestionOptions(options){
      for(let i=0; i<options.length; i++){
        options[i]['index'] = i
      }
      return options.sort(function () { return 0.5 - Math.random() })
    },
    reportQuestion(question){
      console.log(question);
      this.show53kf()
    },
    download(url){
      window.open(url + "?t="+new Date().getTime())
    },
  },
}
</script>
<style lang="less" scoped>
/deep/p{
  margin-bottom: .5em;
}
.ant-layout {
  width: 100%;
  background: transparent;
}
.ant-layout-header {
  min-height: 64px;
  height: unset;
  background: white;
  border-bottom: solid 1px gray;
  line-height: unset;
  .paper-title{
    cursor: pointer;
    line-height: 64px;
  }
  .student-info{
    vertical-align: top;
    padding-top: 10px;
    margin-left: 10px;
    display: inline-block;
  }
  .buttons{
    line-height: 90px;
    text-align: center;
  }
  .timer{
    float:right;
    text-align: center;
  }
}
.ant-layout-sider {
  background: transparent;
  text-align: center;
}
.exam-finished{
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  span{
    text-align: center;
  }
  .exam-score{
    font-size: 4rem;
   }
  .exam-finished-text{
    color: red;
    font-size: 5rem;
  }
  .ant-btn{
    width: 200px; 
    margin: 10px; 
    font-size: 16px; 
    border-radius: 8px;
  }
  .logo{
    img{
      max-height: 200px;
      display: block;
      margin: 48px auto;
    }
  }
}
.ant-modal {
  padding-bottom: 0;
  .ant-modal-close {
    top: -15px;
    right: -15px;
  }
  .video-check-preview{
    margin: auto;
    border: 1px solid black;
    display: block;
  }
  .video-check-tips{
    position: relative;
    top: 20px;
    text-align: center;
    width: 240px;
    height: 0;
    z-index: 1;
    margin: auto;
  }
}
.paper-title {
  h3 {
    display: inline;
  }
}
.remain-time {
  color: red;
  font-size: 40px;
}
.question-side{
  .question-index {
    height: 100%;
    background: white;
    text-align: left;
    /deep/.ant-card-body{
      padding: 10px;
      height: calc(100% - 57px);
    }
    /deep/.ant-row{
      overflow-y: auto;
      overflow-x: hidden;
      height: calc(100% - 35px);
    }
    .question-section {
      margin: 10px 0px;
    }
    .question-item-index{
      margin-bottom: 15px;
      .ant-tag {
        height: 30px;
        width: 30px;
        font-size: 14px;
        line-height: 28px;
        font-weight: 600;
        text-align: center;
        border-width: 2px;
        //color: rgb(35, 155, 215);
      }
    }
    .question-index-desc{
      margin-bottom: 15px;
      .ant-tag{
        height: 18px;
        width: 18px;
        border-radius: 0;
        border-width: 1px;
        display: inline;
      }
    }
  }
}

.paper-content {
  background: transparent;
  .question-card {
    background: transparent;
    /deep/.ant-card-body {
      padding: 10px 5px !important;
    }
  }
  .question-section {
    margin: 10px 0;
    background: rgb(238, 238, 238);
    padding: 3px;
    * {
      display: inline;
    }
  }
  .question-stem {
    width: 100%;
    overflow: auto;
    span,
    >div {
      display: inline-block;
      vertical-align: top;
    }
  }
  .ant-radio-wrapper,
  .ant-checkbox-wrapper {
    display: block !important;
    margin-left: 0px;
    margin-bottom: .5em;
  }
  .question-options-content {
    display: inline-block;
    max-width: calc(100% - 35px);
  }
  .question-letter{
    vertical-align: top;
    margin-right: 10px;
  }
  /deep/.ant-checkbox, /deep/.ant-radio{
    vertical-align: top;
    top: 0.2em;
  }
}
//
/deep/.question-stem-html img{
  max-width: 100%;
  height: auto;
}
// 单页样式
.paper-style-1{
  .ant-layout-content{
    min-height: 50vh;
    height: calc(100vh - 64px);
    overflow: auto;
  }
              //文件题
              .question-file{
              video{
                width:100%;
                max-width: 768px;
              }
              text-align: center;
              .duration{
                  margin-left: 24px;
              }
            }
}
// 一页一题样式
.paper-style-2{
  background: #57a2ff;
  min-height: 100vh;
  /deep/.ant-card{
    border-radius: 20px;
    .ant-card-head{
      background: #d5e6ff;
      border-radius: 20px 20px 0 0;
    }
  }
  .ant-layout-header{
    border-radius: 20px;
    margin: 10px 10px 0 10px;
  }
  .ant-layout-content{
  }
  .question-side{
    padding: 10px;
    /deep/.ant-layout-sider-zero-width-trigger{
      top: 50%;
    }
  }
  .paper-content{
    height: 100%;
    padding: 10px;
    .paper-content-item{
      height: 100%;
      .ant-row{
        height: 100%;
        .ant-col{
          height: 100%;
          // .stem-card{
          //   height: 100%;
          // }
          // .answer-card{
          //   height: calc(100% - 70px);
          // }
          .question-stem{
            font-size: 150%;
          }
          .ant-card{
            height: 100%;
            /deep/.ant-card-body{
              height: calc(100% - 100px);
              overflow: auto;
            }
            //单选 判断
            /deep/.ant-radio-group{
              width: 100%;
              .ant-radio{
                .ant-radio-inner{
                  width: 24px;
                  height: 24px;
                }
                .ant-radio-inner::after{
                  width: 16px;
                  height: 16px;
                }
              }
              .radio-content{
                display: inline-block;
                padding: 5px 10px;
                border-radius: 5px;
                width: calc(100% - 40px);
              }
              .ant-radio-wrapper-checked{
                .radio-content{
                  border: 2px solid rgb(61, 121, 231);
                }
              }
              .ant-radio-wrapper{
                white-space: normal;
                font-size: 150%;
              }
            }
            //多选
            /deep/.ant-checkbox-group{
              width: 100%;
              .ant-checkbox{
                .ant-checkbox-inner{
                  width: 24px;
                  height: 24px;
                }
                .ant-checkbox-inner::after{
                  width: 8px;
                  height: 16px;
                }
              }
              .checkbox-content{
                display: inline-block;
                padding: 5px 10px;
                border-radius: 5px;
                width: calc(100% - 40px);
              }
              .ant-checkbox-wrapper-checked{
                .checkbox-content{
                  border: 2px solid rgb(61, 121, 231);
                  
                }
              }
              .ant-checkbox-wrapper{
                white-space: normal;
                font-size: 150%;
              }
            }
            // 填空
            .question-fill-wrap{
              .question-fill{
                margin: 10px 0;
              }
            }
            // 编程题
            .question-code, .question-oj{
              .ant-btn{
                text-align: center;
                height: 80px;
                font-size: 24px;
              }
            }
            //文件题
            .question-file{
              video{
                width:100%;
                max-width: 768px;
              }
              text-align: center;
              .duration{
                  margin-left: 24px;
              }
            }
          }
        }
      }
    }
  }
  .question-opt-btn{
    padding: 0px 20px 10px 20px;
    width: 100%;
    display: block;
    position: absolute;
    bottom: 0;
    left: 0;
    .switch-btn{
      float: right;
      .ant-btn{
        margin: 0 10px;
      }
    }
  }
}
</style>